import React from 'react';
import RippleButton from './RippleButton';
import './QueryError.css';

export default function QueryError({ error, onRetry }) {
  if (!error) return null;

  const message = error.message || 'An error occurred';
  const userMessage = message
    .replace(/GraphQL\.ExecutionError: /, '')
    .replace(/NotAuthorized: /, 'Permission denied: ')
    .replace(/not found/i, 'not found')
    .replace(/error/i, 'error');

  return (
    <div className="query-error-modern" role="alert">
      <div className="query-error-icon">
        <span className="material-symbols-rounded">error_outline</span>
      </div>
      <div className="query-error-content">
        <h3 className="query-error-title">Something went wrong</h3>
        <p className="query-error-message">{userMessage}</p>
        {onRetry && (
          <RippleButton variant="secondary" onClick={onRetry} className="query-error-retry">
            <span className="material-symbols-rounded" style={{ marginRight: '8px' }}>
              refresh
            </span>
            Try again
          </RippleButton>
        )}
      </div>
    </div>
  );
}
